import React, { useEffect } from 'react'
import { AttendanceTable, Loader } from '../components'
import { getRequest } from '../utils/APICall'
import { useDispatch, useSelector } from 'react-redux'
import { depatmentList, employeeList } from '../redux/employeeSlice'

const Home = () => {
    const dispatch = useDispatch()
    
    const {allEmployee} = useSelector((state) => state.employees || {})

    const {users} = useSelector((state) => state.user || {})
    // console.log(users)
    const fetchAttendance = async() =>{
        try {
            const response = await getRequest(`${users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Accountant"  || users.ROLE_TITLE == "Admin" ? "todayAtt" : "todayAtt?departmentcode=5"}`)
            // console.log(response)
            dispatch(employeeList(response.data))
        } catch (error) {
            console.log(error)
        }
    }
    const getAllDepartment = async() =>{
        try {
            // const response = await getRequest('getAllUser?departmentcode=5')
            const response = await getRequest(`${users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Accountant"  || users.ROLE_TITLE == "Admin" ? "getAllDept" : "getAllDept?departmentcode=5"}`)
            dispatch(depatmentList(response))
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
       if(users){
        fetchAttendance()
        getAllDepartment()
       }
    },[])
    return (
        <>
            {allEmployee ? <AttendanceTable empAttendance={allEmployee}/> : <Loader/>}
        </>
    )
}

export default Home